import { useState } from 'react';
import { Eye, Loader2, Undo2 } from 'lucide-react';
import { toast } from 'sonner';
import type { SessionDto } from '@orienta/shared';
import { errorMessage, http } from '@/lib/api';
import { useAuthed } from '@/features/auth/session';
import { Button } from '@/components/ui/button';

const PERSONA_LABEL: Record<SessionDto['persona'], string> = { admin: 'administração', advisor: 'orientador(a)', student: 'orientando(a)' };

/** Faixa fixa durante o "Ver como", com retorno à administração. */
export function ViewAsBanner() {
  const session = useAuthed();
  const [busy, setBusy] = useState(false);
  if (!session.impersonator) return null;
  return (
    <div role="status" className="bg-warning/15 border-warning/50 flex flex-wrap items-center justify-between gap-2 border-b px-4 py-2 text-sm sm:px-6">
      <p className="flex min-w-0 items-center gap-2">
        <Eye className="size-4 shrink-0" aria-hidden />
        <span className="min-w-0">
          Você está vendo como <strong>{session.user.name}</strong> ({PERSONA_LABEL[session.persona]}
          {session.user.isDemo ? ', conta de demonstração' : ''}). As ações ficam registradas com o seu nome na auditoria.
        </span>
      </p>
      <Button
        size="sm"
        variant="outline"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            const res = await http.post<{ session: SessionDto | null }>('/auth/view-as/stop');
            window.location.assign(res.session ? '/admin/usuarios' : '/entrar');
          } catch (err) {
            toast.error(errorMessage(err));
            setBusy(false);
          }
        }}
      >
        {busy ? <Loader2 className="animate-spin" /> : <Undo2 />}
        Voltar à administração
      </Button>
    </div>
  );
}
